import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const ThemeContext = createContext(null);

function detectInitial() {
  const stored = localStorage.getItem("decide_theme");
  if (stored === "light" || stored === "dark") return stored;
  return "light"; // Light Mode is the default
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(detectInitial);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("decide_theme", theme);
  }, [theme]);

  const toggleTheme = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);
  const setThemeMode = useCallback((mode) => { if (mode === "light" || mode === "dark") setTheme(mode); }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme: setThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
